import { Injectable } from '@angular/core';
import { UsuarioApi, RoleApi } from './lbsdk';
import { AuthService } from './auth/auth.service';

import { of } from 'rxjs/observable/of';
import { flatMap } from 'rxjs/operators';
import { from } from 'rxjs/observable/from';
import { UsuarioSucursalApi,UsuarioSucursal } from './lbsdk';

@Injectable()
export class LoginService {
    // este es el lugar para meter lógica de negocios si la hubiera

    constructor(
        //private customUser: CustomUserApi
        private authUser: AuthService, private customUser: UsuarioApi,
        private roleApi: RoleApi,
        private usuarioEmpresa: UsuarioSucursalApi
    ) { }

    login(data) {
        return this.authUser.login(data.email, data.password);
    }

    OnSubmitUserData(data, newUser: boolean, relationEmpresa) {
        if (newUser) {
            return this.customUser.create(data)
                .flatMap(user => {
                    let relationSave = [];
                    relationEmpresa.forEach(element => {
                        relationSave.push({ idCompany: element.idEmpresa, idUser: user.id })
                    });
                    return of(relationSave)
                })
                .flatMap(res => {
                    return this.usuarioEmpresa.create(res)
                })
        } else {
            console.log("EDIT USER EMMITED->", data);
            delete data.password;
            ///return this.customUser.patchAttributes(data.id, data);
            return this.customUser.patchAttributes(data.id, data)
                .flatMap(update => {
                    
                    //TODO: ARREGLAR
                    //return from(this.usuarioEmpresa.deleteRelationCompanyUser(data.idusuario))
                    return of();
                })
                .flatMap(insert => {
                    let relationSave = [];
                    relationEmpresa.forEach(element => {
                        relationSave.push({ idCompany: element.idEmpresa, idUser: data.id })
                    });
                    return of(relationSave)
                })
                .flatMap(res => {
                    return this.usuarioEmpresa.create(res)
                })
        }
    }

    getUserRoles() {
        return this.roleApi.find();

    }
}



// WEBPACK FOOTER //
// ./src/services/login.service.ts